// disabling this rule as this file should export other constants over time
// eslint-disable-next-line import/prefer-default-export
export const SEARCH_PARAM_SKIP_TO_ADD_PERSONALISE_FIELDS = 'web-add-personalise-fields';
